export enum EFeedbackDetailsBottomLeftTabsOptions {
  Feedback = 0,
  // Survey = 1,
  Service = 1,
}
